export {default as zoom} from "./src/zoom";
export {default as zoomTransform, identity as zoomIdentity} from "./src/transform";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-zoom/index.js
// module id = HtB7
// module chunks = 0